import { useTranslation } from "react-i18next"

import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"

import NewTicketModal from "./NewTicketModal"

export default function TicketsModals() {
  const { t } = useTranslation()
  return (
    <>
      <MyModal
        modalName={MODALS.tickets.add}
        title={t("ticketsModalTitles.newTicket")}
      >
        <NewTicketModal />
      </MyModal>
    </>
  )
}
